import { FC } from 'react';
import {
	Section1,
	Section2,
	Section3,
	Section4,
	Section5,
	Section6,
	Images,
	Links
} from './article4_model';
import '../ArticleComponent.scss';
import './Article4.scss';
import { ButtonComponent } from '../../../UI/ButtonComponent/ButtonComponent';
const Article4Component: FC = () => {
	const handleNavigate = () => {
		window.open(Links.beacon_discovery, '_blank', 'noopener');
	};
	const handleImgAyeya = () => {
		window.open(Links.ayeya, '_blank', 'noopener');
	};
	const handleImgBeaconDiscovery = () => {
		window.open(Links.beacon_discovery, '_blank', 'noopener');
	};
	return (
		<div className='page four'>
			<div className='section--intro'>
				<div className='section-container'>
					<h3 className='section-heading'>{Section1.heading}</h3>
					<p className='info-600'>
						{Section1.content1}{' '}
						<a className='info-600' href={Links.expo_west} target='_blank' rel='noopener'>
							{Section1.content2_link}
						</a>
						<span>{Section1.content3}</span>
						<a className='info-600' href={Links.beacon_discovery} target='_blank' rel='noopener'>
							{Section1.content4_link}
						</a>
						<span>{Section1.content5}</span>
					</p>

					<br></br>
					<p className='info-400 nospace-bottom'>{Section1.content6}</p>
				</div>
			</div>

			<div className='section--image-right-wave first'>
				<div className='section-container'>
					<h3 className='section-heading'>{Section2.heading}</h3>
					<p className='info-600 nospace-bottom'>{Section2.content1}</p>
					<div className='imageRightContentLeft'>
						<div className='content'>
							<ul>
								<li>
									<span className='info-700'>{Section2.item1.boldcontent}</span>
									<span className='info-400'>{Section2.item1.content}</span>
								</li>
								<li>
									<span className='info-700'>{Section2.item2.boldcontent}</span>
									<span className='info-400'>{Section2.item2.content}</span>
								</li>
								<li>
									<span className='info-700'>{Section2.item3.boldcontent}</span>
									<span className='info-400'>{Section2.item3.content}</span>
								</li>
							</ul>
						</div>
						<div className='image'>
							<img src={Images.update_brand} onClick={handleImgBeaconDiscovery} />
						</div>
					</div>

					<p className='info-400'>{Section2.content2}</p>
					<br></br>
					<br></br>
					<p className='info-400'>{Section2.content3}</p>
				</div>
			</div>

			<div className='section--image-right ayeya'>
				<div className='section-container'>
					<h3 className='section-heading'>{Section3.heading}</h3>
					<p className='info-600 nospace-bottom'>{Section3.content1}</p>
					<div className='imageRightContentLeft nospace-bottom'>
						<div className='content'>
							<ul>
								<li>
									<span className='info-700'>{Section3.item1.boldcontent}</span>
									<span className='info-400'>{Section3.item1.content}</span>
								</li>
								<li>
									<span className='info-700'>{Section3.item2.boldcontent}</span>
									<span className='info-400'>{Section3.item2.content}</span>
								</li>
								<li>
									<span className='info-700'>{Section3.item3.boldcontent}</span>
									<span className='info-400'>{Section3.item3.content}</span>
								</li>
							</ul>
						</div>
						<div className='image'>
							<img src={Images.ayeya} onClick={handleImgAyeya} />
							<img src={Images.ayeya_mid} onClick={handleImgAyeya} />
							<img src={Images.ayeya_back} onClick={handleImgAyeya} />
						</div>
					</div>
				</div>
			</div>

			<div className='section--image-right'>
				<div className='section-container'>
					<h3 className='section-heading'>{Section4.heading}</h3>
					<div className='imageRightContentLeft nospace-top nospace-bottom'>
						<div className='content'>
							<p>
								<span className='info-400'>{Section4.content1}</span>
								<a className='info-400' href={Links.market_ready} target='_blank' rel='noopener'>
									{Section4.content2_link}
								</a>
								<span className='info-400'>{Section4.content3}</span>
							</p>
						</div>
						<div className='image'>
							<img src={Images.market_ready} className='non-clickable' />
						</div>
					</div>

					<p className='nospace-bottom'>
						<span className='info-400'>{Section4.content4}</span>
						<a className='info-400' href={Links.market_ready} target='_blank' rel='noopener'>
							{Section4.content5}
						</a>
						<span className='info-400'>{Section4.content6}</span>
					</p>
				</div>
			</div>

			<div className='section--noimage  retailer'>
				<div className='section-container'>
					<h3 className='section-heading'>{Section5.heading}</h3>
					<p className='info-600 nospace-bottom'>{Section5.content1}</p> <br></br>
					<p className='info-400'>{Section5.content2}</p>
				</div>
			</div>

			<div className='section--noimage'>
				<div className='section-container'>
					<h3 className='section-heading'>{Section6.heading}</h3>
					<p className='info-400'>{Section6.content1}</p>
					<br></br>
					<br></br>
					<p className='info-400'>{Section6.content2}</p>
					<div className='button-container'>
						<ButtonComponent
							text={'GET READY TO BE DISCOVERED!'}
							onClick={handleNavigate}
							style={'rounded-button primary addToCart'}
							icon={<i className='ri-arrow-right-s-line arrowIcon'></i>}
						/>
					</div>
				</div>
			</div>
		</div>
	);
};

export default Article4Component;
